<template>
  <div v-if="ready" class="widget">
    <div class="widget-header">
      <ovp-price-widget-header :person-id="personId" :persons="persons" :source="source" @select="selectPerson" />
    </div>
    <div v-if="personId" class="widget-content">
      <ovp-price-widget-product
        :key="`${personId}-${productId}`"
        :person-id="personId"
        :product-id="productId"
        :source="source"
      />
    </div>

    <ovp-modal v-slot="{ modalProps }" v-model="showProductSuggestion" open>
      <ovp-suggestion
        :category-id="suggestion.categoryId"
        :group-id="suggestion.groupId"
        :doctor="suggestion.doctor"
        :person-id="suggestion.personId"
        :product="suggestion.product"
        :source="suggestion.source"
        @added="modalProps.close"
      />
    </ovp-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import OvpPriceWidgetHeader from '@/modules/PriceWidget/components/Header/Header'
import OvpPriceWidgetProduct from '@/modules/PriceWidget/components/Product'

import { OvpSuggestion } from '@/components/Product'
import OvpModal from '@/components/Modal/Modal'

import { ApplicationHelper, BasketHelper, SessionHelper } from '@/helpers'

import { CHANNEL_PRICEWIDGET } from '@/config/constants'
import { EVENT_SHOW_PRODUCT_SUGGESTION } from '@/config/events'

export default {
  name: 'Widget',

  components: {
    OvpModal,
    OvpPriceWidgetHeader,
    OvpPriceWidgetProduct,
    OvpSuggestion,
  },

  props: {
    productId: {
      type: String,
      required: true,
    },

    source: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      personId: null,
      ready: false,
      suggestion: {
        categoryId: null,
        groupId: null,
        doctor: null,
        personId: null,
        product: null,
        source: null,
      },
      showProductSuggestion: false,
    }
  },

  mounted() {
    if (!this.basket.basketId) {
      SessionHelper.autostart({
        channel: CHANNEL_PRICEWIDGET,
        language: ApplicationHelper.getLanguage().toUpperCase(),
      }).then(() => (this.ready = true))
    } else {
      this.ready = true
    }

    this.$EventBus.$on(EVENT_SHOW_PRODUCT_SUGGESTION, opts => {
      this.showProductSuggestion = true
      this.suggestion = { ...opts }
    })
  },

  watch: {
    persons: {
      immediate: true,
      deep: true,
      handler: function (persons) {
        if (this.personId && persons.find(p => p.personId === this.personId)) return

        this.personId = persons[0]?.personId ?? null
      },
    },
  },

  computed: {
    ...mapGetters('basket', ['getPerson', 'getPersons', 'getProduct']),
    ...mapState(['basket']),

    persons() {
      return this.getPersons
    },
  },

  methods: {
    selectPerson(personId) {
      this.personId = personId
    },

    startBasketSession(payload) {
      const createBasket = basket => this.$backend.ovp.createBasket(basket)

      return this.$session
        .start(createBasket, payload)
        .then(basket => SessionHelper.restore(basket))
        .then(basket => BasketHelper.updateBasketSession(basket))
    },
  },
}
</script>

<style name="global">
.tippy-box .tippy-content ul {
  padding-left: 40px !important;
}
.tippy-box p,
.tippy-box .tippy-content ul li {
  color: var(--c-white) !important;
}
</style>

<style name="mobile" scoped>
.widget {
  &-header {
    height: auto;
  }

  &-content {
    background-color: var(--c-white);
    padding: 15px;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .widget {
    &-content {
      padding: 20px;
    }
  }
}
</style>
